export enum ProviderTypes {
    Accommodation = 'Accommodation',
    Mobility = 'Mobility',
    Angel = 'Angel',
    Guiding = 'Guiding',
    POI = 'POI',
    IndividualMobility = 'IndividualMobility'
}